// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from note-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function NoteFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 0a2 2 0 0 1 1.995 1.85L16 2v5a1 1 0 0 1-1 1H7a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H2a2 2 0 0 1-1.995-1.85L0 14V2A2 2 0 0 1 1.85.005L2 0h12Zm1.75 9a.25.25 0 0 1 .25.25L7.25 16a.25.25 0 0 1-.25-.25V10a1 1 0 0 1 1-1h7.75Z"
      />
    </svg>
  );
}
